import React, { Fragment, useEffect, useContext } from "react";
import { TextsContext } from "context/textsContext";
import styleForm from '../../../scss/form.module.scss';
import ValidaComponent, { APPLICATION } from "../../../components/ValidaComponent";
import Stylegeneral from 'scss/general.module.scss'
import { SelectAppComponent } from "components/application/SelectAppComponent";
import { InputTextComponent } from "components/application/InputTextComponent";
import { useLocation } from "react-router-dom";
import { CheckboxComponent } from "components/CheckboxComponent";

const Registro14Page = () => {
    const { texts, verifyCurrentLanguage } = useContext(TextsContext);
    const {pathname} = useLocation();

    useEffect(() => {
		verifyCurrentLanguage();
	}, []);

    return (
        <Fragment>
            <section>
                <div className="container py-3">
                    <div className={`${styleForm.btn_activar}`}>
                        <label htmlFor="examanes" className={`${styleForm.labels} ${styleForm.sin_tootip} raleway  mb-2 color_primary_2 fw_700`}>
                            {texts?.page_fourteen_checkbox_one ?? '¿Alguno de los solicitantes se le ha indicado o se encuentra bajo tratamiento con algún medicamento?'}
                        </label>
                        <div className={`form-check form-switch input-personalizado ${styleForm.col_input}`}>
                            <CheckboxComponent className="form-check-input" type="checkbox" id="examanes" name={"haveDrugs"} section={"/coberturaprevia"} />
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container pb-5">
                    <div className="row gy-4">
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <SelectAppComponent
                                name="solicitante"
                                label={texts?.general_form_field_applicant ?? "Solicitante"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                placeholder='Ej:Colombia'
                                type='text'
                                options={[]}
                            />

                            <ValidaComponent phase={APPLICATION} section={pathname} keyName={"solicitante"} />
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="producto"
                                label={texts?.page_fourteen_form_field_product ?? "Producto"}
                                placeholder={texts?.page_fourteen_form_placeholder_product ?? "Ej: Dolex"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='text'
                            />
                            <ValidaComponent keyName={"producto"} phase={APPLICATION} section={pathname} />
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="cantidad"
                                label={texts?.page_fourteen_form_field_quantity ?? "Cantidad ( Consumida por día )"}
                                placeholder={texts?.page_fourteen_form_placeholder_quantity ?? "Ej: 6 cm"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='text'
                            />
                            <ValidaComponent keyName={"cantidad"} phase={APPLICATION} section={pathname} />
                        </div>

                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="fecha"
                                label={texts?.general_form_field_from ?? "Desde"}
                                placeholder='Ej: Cabeza'
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='date'
                            />
                            <ValidaComponent keyName={"fecha"} phase={APPLICATION} section={pathname} />
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="fechahasta"
                                label={texts?.general_form_field_to ?? "Hasta"}
                                placeholder='Ej: Cabeza'
                                tooltip="Geographic area where the policy´s benefits apply"
                                type='date'
                                required
                            />
                            <ValidaComponent keyName={"fechahasta"} phase={APPLICATION} section={pathname} />
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}
export default Registro14Page;